import React from "react";

const BlogComingSoon = () => {
  return (
    <section className="min-h-screen flex flex-col justify-center items-center bg-blue-950 px-4">
      <div className="max-w-xl text-center">
        <h1 className="text-4xl font-bold text-white mb-4">
          Página em Construção
        </h1>
        <p className="text-lg text-white mb-6">
          O nosso blog ainda está sendo desenvolvido. Em breve teremos conteúdos
          incríveis para você!
        </p>
        <img
          src="https://cdn-icons-png.flaticon.com/512/3447/3447282.png"
          alt="Em construção"
          className="mx-auto mb-6 w-40 h-40 opacity-70"
        />
        <p className="text-sm text-white">
          Enquanto isso, aproveite nossos outros serviços e proteja o que importa!
        </p>
      </div>
    </section>
  );
};

export default BlogComingSoon;